/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.


list

*/
import React, {useState, useEffect } from "react";

import { Card, CardHeader, CardBody, Row, Col, Input } from "reactstrap";

// add new codes
import { useHistory } from 'react-router-dom';
// import NewItem from './NewItem.js';
import dataTypes from "views/diary/dataType.js";

// end

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

function importAll(r) {
  let images = [];
  r.keys().map((item, index) => { 
    var o = {};
    o['name'] = item.replace('./', '');
    o['data'] = r(item);
    // o[item.replace('./', '')] = r(item);
    images.push(o);
    // images[item.replace('./', '')] = r(item); 
  });
  return images;
}

// let images = JSON.stringify(importAll(require.context('assets/img/self/icon', false, /\.(png|jpe?g|svg)$/)));
var aTimeout = null;

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function Setting() {

  let session = window.sessionStorage.getItem('sessions');
  let se = JSON.parse(session);
  if(!se){
    window.location = '/';
  }

  const weekday = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  if(!window.sessionStorage.getItem('s_icons')){
    window.sessionStorage.setItem('s_icons', JSON.stringify(importAll(require.context('assets/img/self/icon', false, /\.(png|jpe?g|svg)$/))));
  }  

  const history = useHistory();

  const [dataItems, setDataItems] = useState([]);
  const [showNewItem, setShowNewItem] = useState('hide');

  const addNewItem = (event) => {
    // history.push('../admin/newItem');
    window.sessionStorage.setItem('editFlag', 0);
    let ics = JSON.parse(window.sessionStorage.getItem('s_icons'));
    // console.log(ics);
    window.sessionStorage.setItem('s_Icon', JSON.stringify(ics[0]));

    window.sessionStorage.setItem('s_day', '7');
    window.sessionStorage.setItem('s_day_name', 'Every day');

    window.sessionStorage.setItem('s_dataType', JSON.stringify(dataTypes.basic[0]));

    window.sessionStorage.setItem('ititle', '');

    window.sessionStorage.setItem('unit', '');

    toPage(event, 'newItem');
  }

  const toPage = (e, pname) => {
    history.push('../admin/'+pname);
  }

  const onSelectItem = (e, item) => {
    if(aTimeout)
      clearTimeout(aTimeout);
    let eFlag = item.eFlag == 1 ? 0 : 1;
    let session = window.sessionStorage.getItem('sessions');
    let se = JSON.parse(session);
    if(!se){
      window.location = '/';
    }
    axios.get(URL_API+"setEnableItems", {
      params: {
        eFlag:eFlag,
        id:item.id,
        user: se['id'],
      }
    })
    .then(function (response) {
      setDataItems(response.data);
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    ); 
  }

  const onEditSelectedItem= (e, item) => {
    // console.log(e, item);
    aTimeout = setTimeout(function(){
      // console.log(e, item);

      window.sessionStorage.setItem('editFlag', 1);

      window.sessionStorage.setItem('selectedItem', JSON.stringify(item));
      let ics = JSON.parse(window.sessionStorage.getItem('s_icons'));

      for(let i=0;i<ics.length;i++){
        if(ics[i].name == item.i_name){
          window.sessionStorage.setItem('s_Icon', JSON.stringify(ics[i]));
          break;
        }
      }
      window.sessionStorage.setItem('ititle', item.title);
      if(item.data_type == 9 || item.data_type == 10 || item.data_type == 11){
        window.sessionStorage.setItem('unit', '');
      }else
        window.sessionStorage.setItem('unit', item.i_unit);

      for(let i=0;i<dataTypes.basic.length;i++){
        // console.log(dataTypes.basic[i].id, item.data_type);
        if(dataTypes.basic[i].id == item.data_type){
          // console.log(dataTypes.basic[i].id, item.data_type);
          window.sessionStorage.setItem('s_dataType', JSON.stringify(dataTypes.basic[i]));
          break;
        }
      }
      window.sessionStorage.setItem('s_day', item.enable_on);
      if(item.enable_on == '7'){
        window.sessionStorage.setItem('s_day_name', 'Every day');
      }else{
        let days = item.enable_on.split(',');
        let daysArr = [];
        for(let i=0;i<days.length;i++){
          daysArr.push(weekday[Number(days[i])]);
        }
        window.sessionStorage.setItem('s_day_name', daysArr.join(','));
      }
      
      toPage(e, 'editItem');
    }, 1000);
    return false;
  }

  const onEditSelectedItem1 = (e, item) => {
    if(window.mobileCheck())
      return;
    onEditSelectedItem(e, item);
  }

  useEffect(() => {
    let session = window.sessionStorage.getItem('sessions');
    let se = JSON.parse(session);
    if(!se){
      window.location = '/';
    }

    if(JSON.parse(window.sessionStorage.getItem('dataItems')) != null){
      setDataItems(JSON.parse(window.sessionStorage.getItem('dataItems')));
    }
    // var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
    // d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);

    axios.get(URL_API+"getDataItems", {
      params: {
        user: se['id']
      }
    })
    .then(function (response) {
      // let d = JSON.parse(response);
      window.sessionStorage.setItem('dataItems', JSON.stringify(response.data));
      setDataItems(response.data);
      // console.log(response);
    }).catch(
      error => {
        if(error.response){
          console.log(error.response.data);
        };
      }
    ); 

  }, []);

  return (
    <>      
      <div className="content px-0 pb-0">
        <div className="titleDiv">
          <Card className="mb-0">
            <CardBody className="seldate p-1 d-flex" id='seldate' style={{color:'white'}}>
              <div className="d-flex col-12 px-2">
                <div className="col-2 col-lg-1 d-flex align-items-center px-0">
                  <i className="fas fa-chevron-left" style={{fontSize:'20px'}} onClick={(event) => toPage(event, 'diary')}></i>
                </div>
                <div className="col-8 col-lg-10 text-center px-0 d-flex align-items-center justify-content-center head_title">
                    設定
                </div>
                <div className="col-2 col-lg-1 px-0">
                </div>
              </div>
            </CardBody>
            <CardBody className="px-0 py-0">
              <div className="col-12 px-0">
                <div className="d-flex align-items-center justify-content-end" style={{height:'50px'}}>
                  <span className="p-1 mr-2" onClick={(event) => addNewItem(event)}><i className="fas fa-plus add_s_items"></i></span>
                </div>
                <div className="col-12 px-0 row mx-0 dataItems">
                  <div className="col-12 px-0">
                  <div className="row col-12 px-0 mx-0">
                  {
                    dataItems.map((item, idx) => 
                      <div key={idx} className={'col-3 p-1 mb-2 ' + (item.eFlag ? 'enabled_item' : 'unEnabled_item')} onTouchStart = {(event) => onEditSelectedItem(event, item)} onClick={(event) => onSelectItem(event, item)} onMouseDown = {(event) => onEditSelectedItem1(event, item)}>
                        <div className="text-center">
                          <img src={item.i_icon}/>
                        </div>
                        <div className="text-center mt-2">
                          <span style={{width:'100%', whiteSpace:'pre-wrap'}}>{item.title}</span>
                        </div>                
                      </div>
                    )
                  }
                  </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
}

export default Setting;
